import { AxiosResponseHeaders } from "axios";
import { apiPrivateAxios, apiPrivateAxiosWithHeaders } from "../../axios";
import { IGetParams } from "../../types";
import { IParams } from "../../../store/types/common";
import { IPatients, IPatientSelector } from "../../../store/patients/types";
import {
  IPatient,
  IPatientWithPrograms,
  ICreatePatient,
  ICreatedPatient,
  IUpdatePatient,
  IPatientServiceStates,
  IBulkPatientAssignPayload,
} from "./types";
import {
  ServiceAppointmentDto,
  ServiceEnrollmentDto,
  CustomizeServiceEnrollmentDto,
} from "../../../store/types/programsServices";
import {
  DEFAULT_ORDER,
  DEFAULT_PATIENT_PAGE_SIZE,
  DEFAULT_SORTING_PATIENTS,
} from "../../../components/common/TopBar/TopBarActions/constants";

export const patientsRequests = {
  getPatient: (id: string): Promise<IPatient> =>
    apiPrivateAxios.get(`/patient/${id}`),
  createPatient: (data: ICreatePatient): Promise<ICreatedPatient> =>
    apiPrivateAxios.post("/patient", data),
  updatePatient: (id: string, data: IUpdatePatient): Promise<IUpdatePatient> =>
    apiPrivateAxios.put(`/patient/${id}`, data),
  getPatients: (
    params?: IParams
  ): Promise<{ data: IPatients[]; headers: AxiosResponseHeaders }> =>
    apiPrivateAxiosWithHeaders.get("/patient?status=Active&status=Inactive", {
      params: {
        ...params,
        inactiveLast: true,
        size: params?.size || DEFAULT_PATIENT_PAGE_SIZE,
        total: true,
        sort: params?.sort || DEFAULT_SORTING_PATIENTS,
        order: params?.order || DEFAULT_ORDER,
      },
    }),
  updatePatientStatus: (data: {
    ids: string[];
    status: string;
  }): Promise<void> => apiPrivateAxios.put("/patient/status", data),
  updatePatientAcuity: (data: {
    ids: string[];
    acuity: string;
  }): Promise<void> => apiPrivateAxios.put("/patient/acuity", data),
  updatePatientHomebound: (data: {
    ids: string[];
    homebound: boolean;
  }): Promise<void> => apiPrivateAxios.put("/patient/homebound", data),
  updatePatientAwv: (data: { ids: string[]; awv: boolean }): Promise<void> =>
    apiPrivateAxios.put("/patient/awv", data),
  updatePatientService: (data: {
    ids: string[];
    actionItem: string;
    states: IPatientServiceStates[];
  }): Promise<void> => apiPrivateAxios.put("/patient/service", data),
  bulkPatientAssign: (data: IBulkPatientAssignPayload): Promise<void> =>
    apiPrivateAxios.post("/patient/bulk-assign", data),
  getPatientSelector: (params?: IGetParams): Promise<IPatientSelector[]> =>
    apiPrivateAxios.get("/patient/selector", { params }),
  uploadPatientCsv: (data: FormData): Promise<IPatients[]> =>
    apiPrivateAxios.post("/patient/batch", data),
  getPatientCsv: (data: { [k: string]: string }): Promise<Blob> =>
    apiPrivateAxios.get("/patient/batch?status=Active&status=Inactive", {
      params: { ...data, inactiveLast: true },
    }),
  getPatientById: (id: string | null): Promise<IPatients> =>
    apiPrivateAxios.get(`/patient/${id}`),
  getPatientWithPrograms: (id: string): Promise<IPatientWithPrograms> =>
    apiPrivateAxios.get(`/patient/${id}/with-programs`),
  getServiceEnrollmentAppointments: (
    patientId: string,
    seId: string
  ): Promise<ServiceAppointmentDto[]> =>
    apiPrivateAxios.get(
      `/patient/${patientId}/service-enrollment/${seId}/appointments`
    ),
  customizeServiceEnrollment: (
    patientId: string,
    seId: string,
    data: CustomizeServiceEnrollmentDto
  ): Promise<ServiceEnrollmentDto> =>
    apiPrivateAxios.put(
      `/patient/${patientId}/service-enrollment/${seId}/customize`,
      data
    ),
};

const patientsRequestsModule = { patientsRequests };

export default patientsRequestsModule;
